/* eslint-disable no-unused-vars */
//import FontAwesome from "@fortawesome/fontawesome-free/js/all";
import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

import UbiNotify from "./ubi-notify/index.js";
Vue.use(UbiNotify);

new Vue({
  render: h => h(App)
}).$mount("#app");
